import React, {useEffect, useState } from "react";
import './TestDataForm.css'

import {
    Form,
    Input,
    Icon,
    Row,
    Col,
    Button,
    Spin
} from 'antd';
import {GET_CAPTCHA} from "../../constants/graphql-query";
import { useLazyQuery } from "@apollo/react-hooks";

const Captcha = ({form : {getFieldDecorator}, isSubmitted}) => {
    const [getCaptcha, { data, loading, refetch }] = useLazyQuery(GET_CAPTCHA, {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
    });
    const [req, updateReq] = useState(false);
    const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

    const getCaptchaImage = () => {
        updateReq(true);
        getCaptcha();
    }

    useEffect(() => {
        if(req === false) {
            getCaptchaImage()
        } else {
            refetch();
        }
    }, []);
    
    return(
        <Row type="flex" align="middle" justify="space-around">
            <Col span={8}>
                <div className="captcha-image">
                {!data || loading ? <Spin indicator={antIcon} /> :<img src={`data:image/jpeg;base64,${data.captcha.image}`} alt="Captcha" /> }
                </div>
            </Col>
            <Col span={10}>
            <Form.Item label="Captcha: ">
                {getFieldDecorator('captcha', {rules: [                    
                    { 
                        validator: (rule, value, callback) => {
                            if(!value) {
                                callback('Please Enter Captcha!');
                                return false;
                            }
                            if(value !== data.captcha.value) {                                
                                callback('Invalid Captcha!');
                                return false;
                            }
                            callback();
                        } 
                    }
                    ]})(<Input autoComplete="Off" disabled={loading}/>)}
            </Form.Item> 
            </Col>
            <Col span={4}><Button loading={loading} icon="sync" onClick={() => refetch && refetch()}/></Col>
        </Row>
    )
}

export default Captcha;